import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Seo from "../components/Seo";
import Reveal from "../components/Reveal";
import FinalCta from "../sections/FinalCta";
import { IMG, JOURNAL, JOURNAL_IMAGE_ALTS, resolveImage } from "../data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function JournalPage() {
  const [entries, setEntries] = useState(JOURNAL);

  useEffect(() => {
    axios
      .get(`${API}/journal`)
      .then((res) => {
        if (Array.isArray(res.data) && res.data.length > 0) setEntries(res.data);
      })
      .catch(() => {});
  }, []);

  return (
    <main data-testid="journal-page">
      <Seo
        title="The Jamoon Journal | Wildlife, Photography & Corbett"
        description="Stories from The Jamoon covering Corbett wildlife, photography, birding, the Ramganga, forests, conservation and life in the wilderness."
        path="/journal"
        image={IMG.journal1}
        imageAlt="An owlet photographed at The Jamoon in Corbett"
        breadcrumbs={[{ name: "Home", path: "/" }, { name: "Journal", path: "/journal" }]}
      />
      <section className="mx-auto max-w-7xl px-6 pb-24 pt-36 sm:px-12 sm:pt-44 lg:px-20">
        <Reveal>
          <p className="text-xs font-medium uppercase tracking-[0.3em] text-brass">Journal</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h1 className="mt-6 max-w-3xl font-serif text-4xl font-light leading-tight tracking-tight text-ivory sm:text-5xl">
            Stories from <span className="italic text-brass">the Wild</span>
          </h1>
        </Reveal>

        <div className="mt-16 grid gap-12 md:grid-cols-2 lg:grid-cols-3">
          {entries.map((j, i) => (
            <Reveal key={j.slug || j.title} delay={(i % 3) * 0.1}>
              <Link
                to={`/journal/${j.slug}`}
                data-testid={`journal-page-card-${i}`}
                className="group block"
              >
                <div className="overflow-hidden">
                  <img
                    src={resolveImage(j.image, 800, 600)}
                    alt={j.imageAlt || JOURNAL_IMAGE_ALTS[j.slug] || `Photograph accompanying ${j.title}`}
                    loading="lazy"
                    className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                </div>
                <p className="mt-5 text-[11px] font-medium tracking-[0.3em] text-brass">
                  {(j.tag || "FIELD NOTES").toUpperCase()}
                </p>
                <h2 className="mt-3 font-serif text-2xl font-light leading-snug text-ivory transition-colors duration-500 group-hover:text-brass">
                  {j.title}
                </h2>
                <p className="mt-3 text-sm leading-relaxed text-ivory/55">{j.excerpt || j.text}</p>
                <p className="mt-4 text-[11px] font-medium tracking-[0.25em] text-ivory/40 transition-colors duration-300 group-hover:text-brass">
                  READ THE NOTE →
                </p>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <FinalCta />
    </main>
  );
}
